import * as React from 'react';

import FormControlWrapper from 'kiini/FormControlWrapper';
import ArgumentValueSelect from '../widgets/ArgumentValueSelect';

import {VAR_ID} from "../constEventHandlers"



const ShowGamePointActionWidget = ({ instance, store, path, ...rest }) => {

    const contentObjectLinksWithName = store.getContentObjectLinksWithName();
    const selectOptions = contentObjectLinksWithName.map(entry => ({ value: entry.id, label: entry.name }));


    return <FormControlWrapper label="Screen to show" showError={false}>
        <ArgumentValueSelect
            instance={instance}
            fieldName="values"
            argumentName={VAR_ID}
            selectOptions={selectOptions} />
    </FormControlWrapper>

}

export default ShowGamePointActionWidget;